import { RouteRecordRaw } from "vue-router";
import store from "@/store";

export const backofficeRoutes: Array<RouteRecordRaw> = [
  {
    path: "backoffice",
    name: "backoffice",
    component: () =>
      import("@/views/backoffice/backoffice-view/backoffice-view.vue"),
    redirect: { name: "backoffice-rooms" },
    children: [
      {
        path: "rooms",
        name: "backoffice-rooms",
        component: () =>
          import("@/views/backoffice/backoffice-rooms/backoffice-rooms.vue")
      },
      {
        path: "coworking",
        name: "backoffice-coworking",
        component: () =>
          import(
            "@/views/backoffice/backoffice-coworking/backoffice-coworking-page/backoffice-coworking-page.vue"
          ),
        redirect: { name: "backoffice-coworking-dashboard" },
        children: [
          {
            path: "dashboard",
            name: "backoffice-coworking-dashboard",
            component: () =>
              import(
                "@/views/backoffice/backoffice-coworking/backoffice-coworking-dashboard/backoffice-coworking-dashboard.vue"
              )
          },
          {
            path: "view",
            name: "backoffice-coworking-view",
            component: () =>
              import(
                "@/views/backoffice/backoffice-coworking/backoffice-coworking-view/backoffice-coworking-view.vue"
              )
          }
        ]
      },
      {
        path: "locker",
        name: "backoffice-locker",
        component: () =>
          import(
            "@/views/backoffice/backoffice-locker/backoffice-locker-page/backoffice-locker-page.vue"
          ),
        redirect: { name: "backoffice-locker-dashboard" },
        children: [
          {
            path: "dashboard",
            name: "backoffice-locker-dashboard",
            component: () =>
              import(
                "@/views/backoffice/backoffice-locker/backoffice-locker-dashboard/backoffice-locker-dashboard.vue"
              )
          },
          {
            path: "view",
            name: "backoffice-locker-view",
            component: () =>
              import(
                "@/views/backoffice/backoffice-locker/backoffice-locker-view/backoffice-locker-view.vue"
              )
          }
        ]
      },
      {
        path: "pass",
        name: "backoffice-pass",
        component: () =>
          import(
            "@/views/backoffice/backoffice-pass/backoffice-pass-page/backoffice-pass-page.vue"
          ),
        redirect: { name: "backoffice-pass-dashboard" },
        children: [
          {
            path: "dashboard",
            name: "backoffice-pass-dashboard",
            component: () =>
              import(
                "@/views/backoffice/backoffice-pass/backoffice-pass-dashboard/backoffice-pass-dashboard.vue"
              )
          },
          {
            path: "view",
            name: "backoffice-pass-view",
            component: () =>
              import(
                "@/views/backoffice/backoffice-pass/backoffice-pass-view/backoffice-pass-view.vue"
              )
          }
        ]
      },
      {
        path: "location",
        name: "backoffice-location",
        component: () =>
          import(
            "@/views/backoffice/backoffice-location/backoffice-location.vue"
          ),
        redirect: { name: "backoffice-location-city-dashboard" },
        children: [
          {
            path: "city-dashboard",
            name: "backoffice-location-city-dashboard",
            component: () =>
              import(
                "@/views/backoffice/backoffice-location/backoffice-location-city-dashboard/backoffice-location-city-dashboard.vue"
              )
          },
          {
            path: "city",
            name: "backoffice-location-city-view",
            component: () =>
              import(
                "@/views/backoffice/backoffice-location/backoffice-location-city-view/backoffice-location-city-view.vue"
              )
          },
          {
            path: "building-dashboard",
            name: "backoffice-location-building-dashboard",
            component: () =>
              import(
                "@/views/backoffice/backoffice-location/backoffice-location-building-dashboard/backoffice-location-building-dashboard.vue"
              )
          },
          {
            path: "building",
            name: "backoffice-location-building-view",
            component: () =>
              import(
                "@/views/backoffice/backoffice-location/backoffice-location-building-view/backoffice-location-building-view.vue"
              )
          },
          {
            path: "floor-dashboard",
            name: "backoffice-location-floor-dashboard",
            component: () =>
              import(
                "@/views/backoffice/backoffice-location/backoffice-location-floor-dashboard/backoffice-location-floor-dashboard.vue"
              )
          },
          {
            path: "floor",
            name: "backoffice-location-floor-view",
            component: () =>
              import(
                "@/views/backoffice/backoffice-location/backoffice-location-floor-view/backoffice-location-floor-view.vue"
              )
          }
        ]
      },
      {
        path: "access",
        name: "backoffice-access",
        component: () =>
          import("@/views/backoffice/backoffice-access/backoffice-access.vue"),
        redirect: { name: "backoffice-access-dashboard" },
        children: [
          {
            path: "dashboard",
            name: "backoffice-access-dashboard",
            component: () =>
              import(
                "@/views/backoffice/backoffice-access/backoffice-access-dashboard-view/backoffice-access-dashboard-view.vue"
              )
          },
          {
            path: "employee",
            name: "backoffice-access-employee",
            component: () =>
              import(
                "@/views/backoffice/backoffice-access/backoffice-access-employee-view/backoffice-access-employee-view.vue"
              )
          }
        ]
      }
    ],
    meta: {
      forMobile: false
    },
    beforeEnter: (to, from, next) => {
      if (store.getters["user/isUserAdmin"]) next();
      else next(false);
    }
  },
  {
    path: "backoffice-sec",
    name: "backoffice-sec",
    component: () =>
      import(
        "@/views/backoffice/backoffice-dashboard-sec/backoffice-dashboard-sec.vue"
      ),
    meta: {
      forMobile: false
    },
    beforeEnter: (to, from, next) => {
      if (store.getters["user/isUserAdmin"] || store.getters["user/isUserSec"])
        next();
      else next(false);
    }
  },
  {
    path: "backoffice-room",
    name: "backoffice-room",
    component: () =>
      import("@/views/backoffice/backoffice-room/backoffice-room.vue"),
    meta: {
      forMobile: false
    },
    beforeEnter: (to, from, next) => {
      if (store.getters["user/isUserAdmin"]) next();
      else next(false);
    }
  }
];
